import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie';
import { RESPONSE } from 'src/express/tokens';
import { APP_BASE_HREF, CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'comparatore-mf';
  isShowBanner: boolean = true;

  constructor(
    @Inject(DOCUMENT) private document: Document, 
    public oidcSecurityService: OidcSecurityService,
    @Optional() @Inject(APP_BASE_HREF) private appBaseHref: any,
    @Optional() @Inject(RESPONSE) private response: any,


  ) {
    
  }

  ngOnInit() {


    this.oidcSecurityService
      .checkAuth()
      .subscribe(({ isAuthenticated, userData, accessToken }) => {
        console.log('app authenticated', isAuthenticated);
        console.log(`checkAuthIncludingServer Current access token is '${accessToken}'`);
      });
  }

  getImgWidth(): number {
    const window = this.document.defaultView;
    return window.innerWidth
  }

  getImageHeight(): number {
    const screenWidth = this.getImgWidth();
    const imgOriginalHeight = 417;
    const imgOriginalWidth = 1334;
    
    return (screenWidth * imgOriginalHeight) / imgOriginalWidth;
  }



}
